import { mapState } from 'vuex'
import debounce from 'lodash/debounce'

const stickyFilters = {
  data () {
    return {
      lastWindowScroll: 0,
      filterStickyTop: 0,
      filterWidth: 0,
      filterTopScrollingUp: 0,
      filterTopScrollingDown: 0,
      filterSizes: null, // measurements-related to filter
      productSizes: null, // measurements-related to products
      isSmallerFilter: false,
      isFixed: null,
      isAbsolute: null,
      isScrollDown: false,
      atTop: false,
      atBottom: false,
      atFooter: false,
      atHeader: true,
      filterPositionCache: {}, // save and reset filter position to avoid "blinks"
      filterSizeTimeout: () => {},
      accordionTransitionDelay: 400, // transition of accordion collapse takes .35 sec
      pageLoadDelay: 3000 // reset filter sizes when DY or youtube loads slow
    }
  },

  computed: {
    ...mapState({
      products: state => state.product.products,
      filtersLoading: state => state.product.filtersLoading
    }),

    fixedSizes () {
      return {
        heights: {
          stickyNav: $('.js-navigation-menu').height() + $('.js-topbar').height(),
          viewport: $(window).height()
        },
        margins: {
          top: 90,
          bottom: 40
        }
      }
    }
  },

  watch: {
    '$route' (to, from) {
      this.clearStickyFilters(true)
      const identicalPrice = to.query['min-price'] === from.query['min-price'] && to.query['max-price'] === from.query['max-price']
      const minMaxPriceChange = !(to.query['min-price'] || to.query['max-price']) // if only either left or right handle moves

      if (!from.query || (!identicalPrice && !minMaxPriceChange)) { // don't reset if not scroll to top
        this.resetStickyFilters()
        return
      }
      this.debounceFilterSize(this.pageLoadDelay)
    },

    products () {
      this.$nextTick(() => this.setProductSizes())
    },

    filtersLoading (newValue) {
      if (newValue) { return }

      this.$nextTick(() => this.setFilterSizes())
    },

    lastWindowScroll () {
      if (!$('.js-sidebar').offset()) { return }

      if (this.isScrollDown) {
        this.filterTopScrollingDown = $('.js-sidebar').offset().top
      } else {
        this.filterTopScrollingUp = $('.js-sidebar').offset().top
      }
    },

    isFixed (newValue) {
      if (this.atHeader) { return }

      if (newValue) {
        if (!this.isScrollDown || this.isSmallerFilter) {
          this.toggleAtTop(true)
        } else {
          this.toggleAtTop(false)
        }
      } else { // is absolute
        if (this.atFooter) {
          this.toggleAtTop(false)
          return
        }

        if (this.isScrollDown) {
          this.setStickyStyles(this.filterTopScrollingUp - this.filterSizes.offsets.filterContainer)
        } else {
          this.setStickyStyles(this.filterTopScrollingDown - this.filterSizes.offsets.filterContainer)
        }
        this.toggleAtTop(null)
      }
    }
  },

  created () {
    window.addEventListener('scroll', this.setStickyFilters, { passive: true })
  },

  destroyed () {
    if (this.filterSizeTimeout) { this.filterSizeTimeout.cancel() }
    window.removeEventListener('scroll', this.setStickyFilters, { passive: true })
  },

  mounted () {
    this.$nextTick(() => {
      this.setFilterSizes()
      this.setProductSizes()
      this.filterWidth = `${$('.js-left-nav').width() - 1}px` // prevent width changes when position changes
    })
    this.debounceFilterSize(this.pageLoadDelay)
  },

  methods: {
    debounceFilterSize (wait) {
      this.filterSizeTimeout = debounce(() => { this.setFilterSizes() }, wait)
      return this.filterSizeTimeout()
    },

    setStickyFilters () {
      this.isScrollDown = window.pageYOffset > this.lastWindowScroll
      this.lastWindowScroll = window.pageYOffset

      const margins = this.fixedSizes.margins
      const fixedHeights = this.fixedSizes.heights
      const filterOffsets = this.filterSizes.offsets
      const filterHeights = this.filterSizes.heights
      const productOffsets = this.productSizes.offsets
      const productHeights = this.productSizes.heights
      const magicNumber = 30
      const productsSmallerThanFilters = productHeights.productList <= filterHeights.filter + filterHeights.breadcrumbs
      const atHeader = window.pageYOffset + fixedHeights.stickyNav < filterOffsets.filter
      const scrollYFromTopWithMargins = window.pageYOffset + margins.top

      if (productsSmallerThanFilters) { return }

      if (atHeader) {
        this.atHeader = true
        this.clearStickyFilters()
        return
      }

      if (this.isSmallerFilter) {
        const atFooter = scrollYFromTopWithMargins + filterHeights.filter + margins.bottom + magicNumber >= productOffsets.indexContent
        if (atFooter) {
          this.toggleIsFixed(false)
          this.atFooter = true
        } else {
          if (this.isFixed) { // toggle to top if already fixed
            this.toggleAtTop(true)
          } else {
            this.toggleIsFixed(true) // smaller filter always stick at the top
          }
          this.atHeader = false
        }
        return
      }

      const scrollYFromBottom = window.pageYOffset + fixedHeights.viewport
      const scrollYFromBottomWithMargins = scrollYFromBottom - margins.bottom

      if (this.isScrollDown) {
        const atFooter = scrollYFromBottom >= productOffsets.indexContent
        const exceedBottom = scrollYFromBottomWithMargins >= this.filterTopScrollingUp + filterHeights.filter
        const withinBounds = scrollYFromTopWithMargins + fixedHeights.stickyNav > this.filterTopScrollingUp

        if (atFooter) {
          this.toggleIsFixed(false)
          this.atFooter = true
        } else if (exceedBottom) {
          this.toggleIsFixed(true)
          this.atHeader = false
        } else if (withinBounds && !this.atHeader) {
          this.toggleIsFixed(false)
        }
      } else {
        const exceedTop = scrollYFromTopWithMargins <= this.filterTopScrollingDown
        const withinBounds = scrollYFromBottomWithMargins < this.filterTopScrollingDown + filterHeights.filter

        if (exceedTop) {
          this.toggleIsFixed(true)
          this.atFooter = false
        } else if (withinBounds && !this.atHeader) {
          this.toggleIsFixed(false)
        }
      }
    },

    setFilterSizes () {
      if (!$('.js-breadcrumbs') || !$('.js-left-nav')) { return }
      if (!$('.js-sidebar').offset()) { return }

      const breadcrumbsHeight = $('.js-breadcrumbs').outerHeight(true)
      const filterContainerOffsetTop = $('.js-left-nav').offset().top

      this.filterSizes = {
        heights: {
          breadcrumbs: breadcrumbsHeight,
          filter: $('.js-sidebar').height()
        },
        offsets: {
          filter: filterContainerOffsetTop + breadcrumbsHeight,
          filterContainer: filterContainerOffsetTop
        }
      }
      this.filterPositionCache = {}
      this.isSmallerFilter = this.fixedSizes.heights.viewport - this.fixedSizes.margins.top > this.filterSizes.heights.filter

      if (!this.isSmallerFilter) {
        this.filterTopScrollingUp = $('.js-sidebar').offset().top // reset the scroll top limit after accordion resizes
      }
    },

    setProductSizes () {
      const indexContent = $('.js-product-index-content')

      if (!indexContent) { return }

      this.productSizes = {
        heights: { productList: $('.js-product-list').height() },
        offsets: { indexContent: indexContent.offset().top + indexContent.outerHeight(true) }
      }
    },

    toggleIsFixed (bool, isReset = false) {
      this.isFixed = bool
      if (bool === null) {
        this.isAbsolute = bool
      } else {
        this.isAbsolute = !bool
      }

      if (!isReset) { this.filterPositionCache.toggleIsFixed = bool }
    },

    toggleAtTop (bool, isReset = false) {
      if (bool === null) {
        this.atTop = false
        this.atBottom = false
      } else {
        this.atTop = bool
        this.atBottom = !bool
        this.setStickyStyles()
      }

      if (!isReset) { this.filterPositionCache.toggleAtTop = bool }
    },

    setStickyStyles (top, isReset = false) {
      this.filterStickyTop = top ? `${top}px` : undefined

      if (!isReset) { this.filterPositionCache.stickyStyles = top }
    },

    clearStickyFilters (isReset = null) {
      this.toggleIsFixed(null, isReset)
      this.toggleAtTop(null, isReset)
      this.setStickyStyles(null, isReset)
    },

    resetStickyFilters () {
      if (Object.keys(this.filterPositionCache).length === 0) { return }

      this.toggleIsFixed(this.filterPositionCache.toggleIsFixed)
      this.toggleAtTop(this.filterPositionCache.toggleAtTop)
      this.setStickyStyles(this.filterPositionCache.stickyStyles)
    }
  }
}

export default stickyFilters
